document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.product-media-modal');
  if (!modal) return;

  const swiperEl = modal.querySelector('.swiper');
  function initSwiper() {
    if (!swiperEl || swiperEl.swiper) return;
    swiperEl.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.product-media-modal .swiper-button-next',
        prevEl: '.product-media-modal .swiper-button-prev',
      },
      pagination: {
        el: '.product-media-modal .swiper-pagination',
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      simulateTouch: true,
      allowTouchMove: true,
    });
  }

  modal.addEventListener('open', initSwiper);
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-media-id]');
    if (!opener) return;
    initSwiper();
  });
});